<script>
import ListMixin from '@/crudBases/list/ListMixin'
import { RankingEntry } from '@/api'

export default {
  mixins: [ListMixin],
  data() {
    return {
      verboseName: 'Ranking',
      verboseNamePlural: 'Ranking',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'username', label: 'nazwa gracza' },
        { prop: 'value', label: 'ilość monet' }
      ]
    }
  },
  methods: {
    actions(scope) {
      return [
        this.getButtonComponent({
          icon: 'el-icon-delete',
          onClick: () => this.handleDelete(scope.$index, scope.row),
          type: 'danger'
        })
      ]
    }
  },
  computed: {
    service() {
      return RankingEntry
    }
  }
}
</script>
